import axios from 'axios';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from '../auth/msalInstance';
import { apiRequest } from '../auth/authConfig';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use(async (config) => {
  const account = msalInstance.getActiveAccount();
  if (account) {
    try {
      const { accessToken } = await msalInstance.acquireTokenSilent({
        ...apiRequest,
        account,
      });
      config.headers.Authorization = `Bearer ${accessToken}`;
    } catch (err) {
      // Silent renewal fails for reasons the user cannot see and did not
      // cause: the Entra session expired, cookies were cleared, or the
      // browser blocked the hidden iframe MSAL uses. Entra answers
      // interaction_required (AADSTS160021). Without this the raw error
      // text surfaced on the page, so a routine re-login read as the
      // feature being broken.
      //
      // Throwing after the redirect is deliberate: the page is navigating
      // away, and returning would send a tokenless request that only 401s.
      if (err instanceof InteractionRequiredAuthError) {
        await msalInstance.acquireTokenRedirect({ ...apiRequest, account });
      }
      throw err;
    }
  }
  return config;
});

export default api;
